export const getTermsAndConditionsUrl = (competition: any) =>
  competition.termsAndConditions?.[0].url;
